document.addEventListener('change', function (event) {
  const input = event.target;
  if (!input.matches('.product-card__swatch-list [type="radio"], .product-card__variant-list [type="radio"]')) return;

  const card = input.closest('product-card');
  if (!card) return;

  const badge = card.querySelector('on-sale-badge.badge--on-sale');
  if (badge) {
    const badgeText = input.getAttribute('data-variant-badge-text');
    if (badgeText) {
      badge.textContent = badgeText;
      badge.removeAttribute('hidden');
    } else {
      badge.hidden = true;
    }
  }

  const priceList = card.querySelector('price-list');
  if (!priceList) return;

  const salePrice = priceList.querySelector('sale-price');
  const compareAtPrice = priceList.querySelector('compare-at-price');
  if (!salePrice) return;

  const variantPrice = input.getAttribute('data-variant-price');
  const variantCompareAtPrice = input.getAttribute('data-variant-compare-at-price');
  if (!variantPrice) return;

  const saleSrOnly = salePrice.querySelector('.sr-only');
  salePrice.textContent = variantPrice;
  if (saleSrOnly) salePrice.prepend(saleSrOnly);
  salePrice.classList.toggle('text-on-sale', !!variantCompareAtPrice);
  salePrice.classList.toggle('text-subdued', !variantCompareAtPrice);

  if (compareAtPrice) {
    if (variantCompareAtPrice) {
      const compareSrOnly = compareAtPrice.querySelector('.sr-only');
      compareAtPrice.textContent = variantCompareAtPrice;
      if (compareSrOnly) compareAtPrice.prepend(compareSrOnly);
      compareAtPrice.removeAttribute('hidden');
    } else {
      compareAtPrice.hidden = true;
    }
  }
});
